import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

/**
 * Global catcher for Supabase password-recovery links. A recovery link is a
 * magic link under the hood: supabase-js consumes the URL hash, signs the user
 * in, and fires PASSWORD_RECOVERY — but nothing routes them anywhere, so
 * without this they just end up logged in wherever the link landed (the
 * reported "forgot password just logs me in" bug).
 *
 * Mounted once inside BrowserRouter so the event is caught no matter which
 * page the link lands on — including the Site URL fallback when a redirectTo
 * isn't on the Supabase auth allow-list. Login.tsx also passes
 * redirectTo=/change-password so the happy path lands there directly.
 */
export const PasswordRecoveryRedirect: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY') {
        navigate('/change-password', { replace: true });
      }
    });
    return () => subscription.unsubscribe();
  }, [navigate]);

  return null;
};
